export default __webpack_public_path__ + "static/media/Glodani 4.20d75a0a.jpg";